import React from "react";

import StartBar from "../../components/StartBar";

import MainScreen from "../../containers/MainScreen";

const IndexPage = () => (
  <>
    <MainScreen />
    <StartBar />
  </>
);

export default IndexPage;
